var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('information-table',{attrs:{"fields":_vm.fields,"items":_vm.courses},on:{"deleteItem":_vm.deleteCourse,"editItem":_vm.editCourse}})}
var staticRenderFns = []

export { render, staticRenderFns }